export default __webpack_public_path__ + "static/media/section2_pic4.bac43c33.webp";